import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import BarChartIcon from '@material-ui/icons/BarChart';
import DialogMetrics from "./DialogMetrics";
import {
  IconButton,
  Button,
  Menu,
  MenuItem
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  // Add custom styles if needed
}));

export default function ButtonMetrics({ project }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCustomerReport = () => {
    handleClose();
    setIsDialogOpen(true);
  };

  const handleOutOfDateReport = () => {
    handleClose();
    const url = `/company-report-tool-out-of-date/${project.user_type_id}/${project.id}`;
    window.open(url, '_blank');
  };
  const handleOutOfDateStoreReport = () => {
    handleClose();
    const url = `/company-report-tool-out-of-date-store/${project.user_type_id}/${project.id}`;
    window.open(url, '_blank');
  };
  const handleCheckedReportPage = () => {
    handleClose();
    window.open(`/company-report-tool-checked-report/${project.user_type_id}/${project.id}`, '_blank');
  };
  const handleStalePriceReportsPage = () => {
    handleClose();
    window.open(
      `/company-report-tool-stale-price-reports/${project.user_type_id}/${project.id}`,
      '_blank'
    );
  };
  const handleStalePriceReportsByPmgPage = () => {
    handleClose();
    window.open(
      `/company-report-tool-stale-price-reports-by-pmg/${project.user_type_id}/${project.id}`,
      '_blank'
    );
  };
  const handleStalePriceReportsByBannerPage = () => {
    handleClose();
    window.open(
      `/company-report-tool-stale-price-reports-by-banner/${project.user_type_id}/${project.id}`,
      '_blank'
    );
  };
  const handleStalePriceReportsByCityPage = () => {
    handleClose();
    window.open(
      `/company-report-tool-stale-price-reports-by-city/${project.user_type_id}/${project.id}`,
      '_blank'
    );
  };
  const handleMetricsClose = () => {
    setIsDialogOpen(false);
  };


  return (
    <>
      {project && (
        <Button
          color="primary"
          className={classes.button}
          onClick={handleClick}
          endIcon={<BarChartIcon />}
        >
          Metrics
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleCustomerReport}>Customer Report</MenuItem>
        <MenuItem onClick={handleOutOfDateReport}>Not updated price Report</MenuItem>
        <MenuItem onClick={handleOutOfDateStoreReport}>Not updated price detail by store Report</MenuItem>
        <MenuItem onClick={handleCheckedReportPage}>Not updated Checked on Store Report</MenuItem>
        <MenuItem onClick={handleStalePriceReportsPage}>Customer Stale Price Reports</MenuItem>
        <MenuItem onClick={handleStalePriceReportsByPmgPage}>Customer Stale Price Reports (by PMG)</MenuItem>
        <MenuItem onClick={handleStalePriceReportsByBannerPage}>Customer Stale Price Reports (by Banner)</MenuItem>
        <MenuItem onClick={handleStalePriceReportsByCityPage}>Customer Stale Price Reports (by City)</MenuItem>
        {/* <MenuItem onClick={handleStatusByCityChart}>Not updated Status by City Report</MenuItem> */}
      </Menu>
      <DialogMetrics
        open={isDialogOpen}
        onClose={handleMetricsClose}
        project={project}
      />
    </>
  );
} 